/**
 * Reducer to fetch types of an asset.
 */

import axios from 'axios';
import { AsyncAction } from '..';
import { AssetType } from '../../types/asset';

type State = {
    fetched: boolean;
    fetching: boolean;
    items: { [id: number]: AssetType };
    error?: Error;
};

type Action = { type: 'asset/type/get'; payload?: { items: State['items'] }; error?: Error };

const initialState: State = {
    fetched: false,
    fetching: false,
    items: {},
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'asset/type/get':
            if (action.payload) return { ...state, fetched: true, fetching: false, ...action.payload };
            if (action.error) return { ...state, fetching: false, error: action.error };
            return { ...state, fetching: true };
        default:
            return state;
    }
};

/**
 * Request all asset types from the server.
 * If the types are already fetched, they are not fetched again.
 * 
  @param rethrow throw the internal error
 */
const get = (rethrow = false): AsyncAction => async (dispatch, getState) => {
    const { asset_type } = getState();
    if (asset_type.fetched) return;
    try {
        dispatch({ type: 'asset/type/get' });
        const response = await axios.get<AssetType[]>('/asset-types');
        const items = response.data.reduce<{ [id: number]: AssetType }>((acc, t) => ((acc[t.id] = t), acc), {});
        dispatch({ type: 'asset/type/get', payload: { items } });
    } catch (error) {
        dispatch({ type: 'asset/type/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { get };
